import { CSSProperties } from "react";
import styles from "./styles.module.scss";

export function SupportTicketsHeader({
  totalIssues,
  circleLabel,
  title,
  color,
}: any) {
  const totalIssuesLable = totalIssues > 1 ? "Issues" : "Issue";
  return (
    <div className={styles.supportTicketsHeader}>
      <div
        className={styles.sportNameCircleIcon}
        style={{ "--color": color } as CSSProperties}
      >
        {circleLabel}
      </div>
      <div className={styles.label}>
        {title}{" "}
        <span>
          ({totalIssues} {totalIssuesLable})
        </span>
      </div>
    </div>
  );
}
